<template>
    <div class="content-account-header">
        <template v-if="this.$route.name == 'Account'">
            <button class="content-account-header-text btn-return">
                <h3>as suas participações</h3>
            </button>
        </template>
        <template v-else>
            <button class="content-account-header-text btn-return" tag="a" @click="hasHistory() 
                ? $router.go(-1) 
                : $router.push('/')">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="69" height="69" viewBox="0 0 69 69">
                    <defs>
                        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#fece09"/>
                        <stop offset="1" stop-color="#f5891f"/>
                        </linearGradient>
                        <filter id="Ellipse_2" x="0" y="0" width="69" height="69" filterUnits="userSpaceOnUse">
                        <feOffset dy="6" input="SourceAlpha"/>
                        <feGaussianBlur stdDeviation="6" result="blur"/>
                        <feFlood flood-opacity="0.161"/>
                        <feComposite operator="in" in2="blur"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                    </defs>
                    <g id="Group_2353" data-name="Group 2353" transform="translate(-18 -43)">
                        <g transform="matrix(1, 0, 0, 1, 18, 43)" filter="url(#Ellipse_2)">
                        <circle id="Ellipse_2-2" data-name="Ellipse 2" cx="16.5" cy="16.5" r="16.5" transform="translate(18 12)" fill="url(#linear-gradient)"/>
                        </g>
                        <path id="Union_1" data-name="Union 1" d="M11.562,0h.723V12.285h-.723V.723H0V0Z" transform="translate(55.187 79.873) rotate(-135)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </g>
                </svg>
                <h3>as suas participações</h3>
            </button>
        </template>
        
        <div class="content-account-header-clock" v-if="shouldShowClock">
            <div class="content-account-header-clock-text ">
                <p>Grande Sorteio faltam:</p>
                <div class="content-account-header-clock-text-counter">
                    <p><span>30</span> dias: <span>4</span> horas: <span>15</span> min</p>
                </div>
            </div>
            <div class="content-account-header-clock-img">
                <img src="@/assets/img/account/rise_mockup.png" alt="rise mockup">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    shouldShowClock() {
        return false;
    //   return this.screenWidth >= 992 && this.$route.name === 'AccountCode';
    },
  },
  created() {
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    hasHistory() {
        return window.history.length > 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.content-account-header{
        width: 100%;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 992px){
            flex-direction: column-reverse;
            align-items: flex-start;
        }
        &-text {
            all: unset;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            h3::first-letter{
                text-transform: capitalize;
            }
        }
        &-clock{
            width: 325px;
            height: 100px;
            position: relative;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            &-text{
                width: 292px;
                p{
                    font-family: 'Font Bold';
                    font-size: 18px;
                    color: var(--main-color);
                    text-transform: uppercase;
                    margin: 0;
                    text-align: end;
                }
                &-counter{
                    height: 43px;
                    width: 292px;
                    background: rgb(31,125,101);
                    background: linear-gradient(90deg, rgba(31,125,101,1) 0%, rgba(0,179,115,1) 100%);
                    border-radius: 30px;
                    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
                    padding: 0 30px;
                    p{
                        font-family: 'Font Regular';
                        color: var(--white);
                        text-transform: lowercase;
                        span{
                            font-family: 'Font Bold';
                            color: var(--white);
                            font-size: 24px;
                            line-height: 24px;
                        }
                    };
                }
            
                
            }
            &-img{
                position: absolute;
                left: 0;
                top: 0;
                img{
                    width: 100px;
                    height: 100px;
                }
            }
            
        }
    }
</style>